import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_PRESCRIPTIONS_DETAILS_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetPrescriptionDetailsPayload, GetPrescriptionDetailsResult } from '../types/getPrescriptionDetails.type';

export const TAG_MEDREFILL_PRESCRIPTION_DETAILS = 'getPrescriptionDetails';

export const getPrescriptionDetails = <T extends BuilderType>(builder: T) =>
  builder.query<GetPrescriptionDetailsResult, GetPrescriptionDetailsPayload>({
    providesTags: [TAG_MEDREFILL_PRESCRIPTION_DETAILS],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_MEDREFILL_PRESCRIPTIONS_DETAILS_URL,
      isErrMsgConcatErrCode: false,
    }),
    transformResponse: (response: GenericApiResponse<GetPrescriptionDetailsResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
